/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, FormLabel, MenuItem, Stack, TextField, Typography } from "@mui/material";

import { useNavigate, useParams } from "react-router-dom";

import {
	faChalkboardUser,
	faChevronLeft,
	faChevronRight,
	faPlus,
	faArrowsRotate,
	faNewspaper,
	faArrowUpRightAndArrowDownLeftFromCenter,
	faPencil,
	faTrash,
	faPhone,
	faLoader,
	faHand,
} from "@fortawesome/pro-regular-svg-icons";

import { faHand as faHandSolid } from "@fortawesome/pro-solid-svg-icons";

import { useCallback, useEffect, useMemo, useRef, useState, useLayoutEffect } from "react";

import { useTranslation } from "react-i18next";

import Markdown from "react-markdown";

import rehypeRaw from "rehype-raw";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { FileUploader } from "react-drag-drop-files";

import { DeleteOutlineRounded } from "@mui/icons-material";

import { TrackReference } from "@livekit/components-react";

import UploadCloud from "@assets/icons/upload-cloud.svg?react";

import { SvgIcon } from "@/components/Icon/SvgIcon";

import { Modal, Icon, PermissionCheck, Loader } from "@/components";

import { Button } from "@/components/Button/Button";

import { ButtonColor, ButtonSize, FontSize } from "@/components/Button/types";

import { useAppSelector } from "@/redux/hooks";

import { isValidUrl } from "@/utils/isValidUrl";

import { PermissionRoles, Role } from "@/enum";

import { usePageTitle } from "@/utils/usePageTitle";

import { ROUTE_CONFIG } from "@/routes/config";

import { Tab, TabsContainer } from "@/components/Tabs/TabsContainer";

import { truncateText } from "@/utils/truncateText";

import { FlagHeader } from "@/components/Modals/FlagHeader";

import {
	useSendUploadedFilesMutation,
	useRemoveUploadedFileMutation,
	useRemoveAllUploadedFilesMutation,
} from "@/pages/Private/redux/course-progress/course-progress.api";

import { HoveredButton } from "@/components/HoveredButton/HoveredButton";

import CourseTag from "../../Courses/components/CourseList/CourseTag";
import {
	EMPTY_COURSE_SCENARIO,
	IStageContentInfo,
	UploadedTempFilePage,
} from "../../Courses/constants/emptyCourseScenario";
import { FileTypes } from "../../Courses/enums/FileTypes.enum";
import { useSocket } from "../context/SocketContext";
import { CourseProgressResponse } from "../schema/course-progress";
import AddTeamModal from "./AddTeamModal";
import Breadcrumbs from "./Breadcrumbs";
import Chat from "./ChatComponents/Chat";
import ListConnectedUsers from "./ConnectedUsers/ListConnectedUsers";
import CountdownTimer from "./CountdownTimer";
import InformationTab from "./InformationTab";
import Protocol from "./Protocol";
import SpoilerModal from "./SpoilerModal";
import { renderContent } from "../utils/render-content";
import VoiceChat from "./VoiceChat/VoiceChat";
import { TempUploadedFile } from "../../Courses/components/StartCourseModal";
import { IConnectedUser, IDefaultParticipant } from "../interfaces/IConnectedUser.interface";

interface CourseInProgressProps {
	data?: CourseProgressResponse;
	setCurrentShowingContentInfo: (data: IStageContentInfo | null) => void;
}

export default function CourseInProgress({
	data,
	setCurrentShowingContentInfo,
}: CourseInProgressProps) {
	const { t } = useTranslation();
	const ts = (key: string) => t(`courses.progress.${key}`);

	usePageTitle(t("courses.title"));
	const { id } = useParams();
	const [currentShowingContentId, setCurrentShowingContentId] = useState("");
	const [isSpoilerModalShown, setIsSpoilerModalShown] = useState(false);
	const [protocolCondition, setProtocolCondition] = useState<"MINIMIZED" | "EXPANDED" | "NORMAL">(
		"NORMAL"
	);
	const currentUserId = useAppSelector((state) => state.auth?.user?.id ?? -1);

	const currentUser = useAppSelector((state) => state.auth?.user);

	const alreadyHasOpenedContentIds = useRef<string[]>([]);
	const {
		sendChatMessage,
		chatMessages,
		sendScenarioAction,
		getScenarioActualData,
		currentStage,
		sendDrawing,
		drawingCoords,
		clearDrawing,
		uploadedFiles,
		changeSelectedFileAndPages,
		currentStageEndTimestamp,
		stageContent,
		pageContent,
		setUploadedFiles,
		isCurrentUserERR,
		currentlySelectedFileAndPage,
		handleFileDownload,
		handleRaiseHand,
		raisedHands,
	} = useSocket();
	const [isShowAddTeamModal, setIsShowAddTeamModal] = useState(false);
	const userPermissions = useAppSelector((state) => state.auth?.user?.role.permissions);
	const [changeSelectedMode, setChangeSelectedMode] = useState<"WHITEBOARD" | "CONTENT">("CONTENT");
	const isPresenter = userPermissions?.some((perm) => perm.code === "PRESENTER");

	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [isChangeFileModalOpen, setIsChangeFileModalOpen] = useState(false);
	const [isExpandFileShowing, setIsExpandFileShowing] = useState(false);
	const [isFileExpanded, setIsFileExpanded] = useState(false);
	const [isDrawingMode, setIsDrawingMode] = useState(false);
	const [isStartedDrawing, setIsStartedDrawing] = useState(false);
	const [mouseCoords, setMouseCoords] = useState<
		{
			xCoords: number | null;
			yCoords: number | null;
			id?: string;
		}[]
	>([]);
	const imgRef = useRef<HTMLImageElement>(null);
	const imgRefModal = useRef<HTMLImageElement>(null);

	const canvasRef = useRef<HTMLCanvasElement>(null);
	const canvasRefModal = useRef<HTMLCanvasElement>(null);

	const divRef = useRef<HTMLDivElement>(null);

	const [isJoinedVC, setIsJoinedVC] = useState(true);

	const [sendUploadedFiles, { error: uploadError, isLoading: uploadIsLoading }] =
		useSendUploadedFilesMutation();
	const maxFileSizeInBytes = 50 * 1024 * 1024;
	const [isFileLoading, setIsFileLoading] = useState(uploadIsLoading);
	const [removeUploadedFile] = useRemoveUploadedFileMutation();
	const [removeAllUploadedFiles] = useRemoveAllUploadedFilesMutation();
	const [uploadedFilesArr, setUploadedFilesArr] = useState<TempUploadedFile[]>([]);

	const getCtxAndCanvas = (): {
		canvas: HTMLCanvasElement | null;
		ctx: CanvasRenderingContext2D | null;
	} => {
		const canvas = isFileExpanded ? canvasRefModal.current : canvasRef.current;
		const ctx = canvas?.getContext("2d") ?? null;

		return { canvas, ctx };
	};

	const redrawLines = useCallback(
		(
			coords: {
				xCoords: number | null;
				yCoords: number | null;
				id?: string;
				userId?: string | number;
			}[],
			ctx: CanvasRenderingContext2D,
			canvas: HTMLCanvasElement
		) => {
			if (coords.length > 0) {
				ctx.clearRect(0, 0, canvas.width, canvas.height);
			}

			const coordsInPx = coords
				.map((coord) => {
					if (coord.xCoords === null || coord.yCoords === null) {
						return { xCoords: null, yCoords: null, id: coord.id, userId: coord.userId };
					} else {
						return {
							xCoords: (coord.xCoords * canvas.width) / 100,
							yCoords: (coord.yCoords * canvas.height) / 100,
							id: coord.id,
							userId: coord.userId,
						};
					}
				})
				.sort((a, b) => {
					if (a.userId && b.userId && a.userId.toString() > b.userId.toString()) {
						return 1;
					} else if (a.userId && b.userId && a.userId.toString() < b.userId.toString()) {
						return -1;
					}

					return 0;
				});

			for (let i = 1; i < coordsInPx.length; i++) {
				const start = coordsInPx[i - 1];
				const end = coordsInPx[i];

				if (
					(start?.xCoords === null && start?.yCoords === null) ||
					(end?.xCoords === null && end?.yCoords === null) ||
					start?.userId !== end?.userId
				) {
					continue;
				}

				drawingLines("#000", start.xCoords, start.yCoords, end.xCoords, end.yCoords, ctx);
			}
		},
		[]
	);

	const updateCanvasProportions = useCallback(() => {
		const img =
			isFileExpanded && !currentlySelectedFileAndPage?.blank ? imgRefModal.current : imgRef.current;

		const div = currentlySelectedFileAndPage?.blank ? divRef.current : null;

		const { ctx, canvas } = getCtxAndCanvas();

		if (canvas && ctx && img) {
			canvas.width = img.clientWidth;
			canvas.height = img.clientHeight;
			redrawLines(drawingCoords, ctx, canvas);
		} else if (canvas && ctx && div) {
			canvas.width = div.clientWidth;
			canvas.height = div.clientHeight;
			redrawLines(drawingCoords, ctx, canvas);
		}

		setIsDrawingMode(false);
	}, [isFileExpanded, getCtxAndCanvas]);

	useEffect(() => {
		if (currentlySelectedFileAndPage?.blank && changeSelectedMode === "WHITEBOARD") {
			const timer = setTimeout(() => {
				updateCanvasProportions();
			}, 100);

			return () => clearTimeout(timer);
		}
	}, [changeSelectedMode]);

	useEffect(() => {
		window.addEventListener("resize", updateCanvasProportions);

		return () => {
			window.removeEventListener("resize", updateCanvasProportions);
		};
	}, [isFileExpanded, updateCanvasProportions]);

	function handleStartDrawing(event: React.MouseEvent<HTMLCanvasElement>) {
		if (!isDrawingMode || (!isPresenter && !isCurrentUserERR)) {
			return;
		}

		if (isDrawingMode) {
			setIsStartedDrawing(true);

			const { offsetX, offsetY } = event.nativeEvent;

			setMouseCoords((prev) => [
				...prev,
				{ xCoords: null, yCoords: null, id: crypto.randomUUID() },
				{ xCoords: offsetX, yCoords: offsetY, id: crypto.randomUUID() },
			]);
		}
	}

	function handleCurrentlyDrawing(event: React.MouseEvent<HTMLCanvasElement>) {
		if (!isStartedDrawing) {
			return;
		}

		if (isStartedDrawing) {
			const { offsetX, offsetY } = event.nativeEvent;

			setMouseCoords((prev) => [
				...prev,
				{ xCoords: offsetX, yCoords: offsetY, id: crypto.randomUUID() },
			]);
		}
	}

	const handleFileSelect = useCallback(
		(selectedFileId: number | null, selectedFilePage: number | null = 1, blank = false) => {
			if (!blank) {
				clearDrawing([]);
				changeSelectedFileAndPages(selectedFileId, selectedFilePage);
				handleClearDrawing();
				setIsLoading(true);
			} else if (blank) {
				clearDrawing([]);
				changeSelectedFileAndPages(null, null, true);
				setIsLoading(false);
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[changeSelectedFileAndPages]
	);

	const handleClearDrawing = useCallback(() => {
		clearDrawing([]);
		setMouseCoords([]);
	}, [clearDrawing, currentlySelectedFileAndPage]);

	function handleStopDrawing() {
		if (isStartedDrawing) {
			setMouseCoords((prev) => {
				const newCoords = [...prev, { xCoords: null, yCoords: null, id: crypto.randomUUID() }];

				setIsStartedDrawing(false);

				return newCoords;
			});
		}
	}

	useEffect(() => {
		if (drawingCoords.length !== 0) {
			return;
		}

		const { ctx, canvas } = getCtxAndCanvas();

		if (!ctx || !canvas) {
			return;
		}

		ctx.clearRect(0, 0, canvas.width, canvas.height);
		setMouseCoords([]);
	}, [clearDrawing, drawingCoords.length, handleFileSelect, handleFileDownload]);

	function drawingLines(
		color: string,
		x_start: number,
		y_start: number,
		x_end: number,
		y_end: number,
		board: CanvasRenderingContext2D
	) {
		board.beginPath();
		board.strokeStyle = color;
		board.lineWidth = 2;
		board.moveTo(x_start, y_start);
		board.lineTo(x_end, y_end);

		board.stroke();
		board.closePath();
	}

	useLayoutEffect(() => {
		const { ctx, canvas } = getCtxAndCanvas();

		if (!ctx || !canvas) {
			return;
		}

		redrawLines(drawingCoords, ctx, canvas);
	}, [drawingCoords, getCtxAndCanvas]);

	useLayoutEffect(() => {
		const { canvas } = getCtxAndCanvas();

		if (!canvas) {
			return;
		}

		const coordsInPercentages = mouseCoords.map((coord) => ({
			xCoords: coord.xCoords === null ? null : (100 * coord.xCoords!) / canvas!.width,
			yCoords: coord.yCoords === null ? null : (100 * coord.yCoords!) / canvas!.height,
			id: coord.id ?? "0",
		}));

		if (isStartedDrawing) {
			sendDrawing(coordsInPercentages);
		}
	}, [getCtxAndCanvas, isStartedDrawing]);

	const selectedPage: UploadedTempFilePage | undefined = pageContent.find(
		(page) => page.pageNumber === currentlySelectedFileAndPage?.page
	);

	useEffect(() => {
		setIsLoading(false);
	}, [selectedPage]);

	const lastPage = pageContent[pageContent.length - 1]?.pageNumber;

	useEffect(() => {
		if (currentlySelectedFileAndPage?.id && !currentlySelectedFileAndPage?.blank) {
			handleFileDownload(currentlySelectedFileAndPage.id);
			setIsLoading(true);
		} else if (currentlySelectedFileAndPage?.blank) {
			setIsLoading(false);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentlySelectedFileAndPage?.id, changeSelectedFileAndPages]);

	const handleNavigationWithArrowKeys = useCallback(
		(e: KeyboardEvent) => {
			if (!(changeSelectedMode === "WHITEBOARD" && (isCurrentUserERR || isPresenter))) {
				return;
			}

			switch (e.key) {
				case "ArrowRight":
					if (
						currentlySelectedFileAndPage?.id &&
						currentlySelectedFileAndPage?.page !== lastPage &&
						currentlySelectedFileAndPage?.page
					) {
						handleFileSelect(
							currentlySelectedFileAndPage.id,
							currentlySelectedFileAndPage?.page + 1
						);
					}

					break;
				case "ArrowLeft":
					if (
						currentlySelectedFileAndPage?.id &&
						currentlySelectedFileAndPage?.page !== 1 &&
						currentlySelectedFileAndPage?.page
					) {
						handleFileSelect(
							currentlySelectedFileAndPage.id,
							currentlySelectedFileAndPage?.page - 1
						);
					}

					break;
				default:
					return;
			}
		},
		[
			changeSelectedMode,
			currentlySelectedFileAndPage?.id,
			currentlySelectedFileAndPage?.page,
			handleFileSelect,
			isCurrentUserERR,
			isPresenter,
			lastPage,
		]
	);

	useEffect(() => {
		window.addEventListener("keydown", handleNavigationWithArrowKeys);

		return () => window.removeEventListener("keydown", handleNavigationWithArrowKeys);
	}, [changeSelectedMode, handleNavigationWithArrowKeys, isCurrentUserERR, isPresenter]);

	useEffect(() => {
		stageContent?.forEach((info) => {
			if (
				info?.id &&
				info?.autoplay &&
				info?.timeStamp &&
				info?.timeStamp + 10000 > Date.now() &&
				!alreadyHasOpenedContentIds.current?.includes(info?.id)
			) {
				setCurrentShowingContentInfo(info);
				alreadyHasOpenedContentIds.current.push(info.id);

				return;
			}
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [stageContent]);

	const currentCourseScenario = useMemo(() => {
		if (data?.course?.json) {
			return data?.course?.json;
		}

		return EMPTY_COURSE_SCENARIO;
	}, [data]);

	const currentStageSpoiler = useMemo(() => {
		if (stageContent?.length) {
			const currentStageId = currentCourseScenario?.Content?.[currentStage]?.id;

			if (currentStageId) {
				const spoilerInfo = stageContent?.find(
					(item) =>
						item.stageNumber === currentStageId &&
						item.contentType?.toUpperCase() === FileTypes.Spoiler
				);

				return spoilerInfo ?? null;
			}
		}

		return null;
	}, [currentCourseScenario, currentStage, stageContent]);

	useEffect(() => {
		getScenarioActualData();
	}, [getScenarioActualData]);

	useEffect(() => {
		if (stageContent?.length) {
			const currentStageId = currentCourseScenario?.Content?.[currentStage]?.id;

			if (currentStageId) {
				const currentStageActualContentId = stageContent?.findIndex(
					(item) =>
						item.stageNumber === currentStageId &&
						item.contentType?.toUpperCase() !== FileTypes.Spoiler
				);

				if (currentStageActualContentId !== -1) {
					setCurrentShowingContentId(stageContent[currentStageActualContentId]?.id ?? "");
				} else {
					const lastContentId = stageContent?.findIndex(
						(item) =>
							item.contentType?.toUpperCase() !== FileTypes.Spoiler && !isValidUrl(item?.content)
					);

					if (lastContentId !== -1) {
						setCurrentShowingContentId(stageContent[lastContentId]?.id ?? "");
					} else {
						setCurrentShowingContentId("");
					}
				}
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentStage, stageContent]);

	const audioRef = useRef<HTMLAudioElement | null>(null);
	const [isAudioPlaying, setIsAudioPlaying] = useState(false);

	const currentContent = useMemo(() => {
		const existedContent = stageContent?.find((item) => item.id === currentShowingContentId);

		return !!existedContent && !isValidUrl(existedContent?.content)
			? (existedContent?.content ?? ts("content-cannot-be-displayed"))
			: existedContent?.content && !!isValidUrl(existedContent?.content)
				? renderContent(t, ts, existedContent, audioRef, isAudioPlaying, setIsAudioPlaying)
				: ts("content-cannot-be-displayed");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentShowingContentId, stageContent, isAudioPlaying]);

	function handlePopUpFile() {
		setIsFileExpanded(true);
	}

	const [isHoveringOnCall, setIsHoveringOnCall] = useState(false);

	const [isUploadModalOpen, setIsUploadModalOpen] = useState<boolean>(false);

	async function handleRemoveUploadedFile(fileId: number) {
		try {
			await removeUploadedFile(fileId).unwrap();

			setUploadedFilesArr((prev) => prev.filter((file) => file.id !== fileId));
			if (pageContent[0]?.uploadedFileId === fileId) {
				handleFileSelect(null, null, false);
			}
		} catch (err) {
			console.error(err);
		} finally {
			getScenarioActualData();
		}
	}

	async function handleCloseStartModal(uploadedFiles: TempUploadedFile[]) {
		try {
			const removedFileIds = uploadedFiles.map((file) => file.id);

			setIsUploadModalOpen(false);
			if (removedFileIds.length > 0) {
				await removeAllUploadedFiles(removedFileIds).unwrap();
				setUploadedFilesArr([]);
			}
		} catch (err) {
			console.error(err);
		}
	}

	async function handleFileUpload(file: File, id: string) {
		setIsFileLoading(true);
		const selectedFiles = file instanceof FileList ? Array.from(file) : file;

		if (Array.isArray(selectedFiles)) {
			for (const file of selectedFiles) {
				const formData = new FormData();

				formData.append("file", file);
				formData.append("courseProgressId", id);
				try {
					const res = await sendUploadedFiles(formData).unwrap();

					const newUploadedFile: TempUploadedFile = {
						...res,
						id: res.uploadedFileId,
					};

					setUploadedFilesArr((prev) => [...prev, newUploadedFile]);
				} catch (error) {
					console.error("Upload error", error);
				}
			}

			setIsFileLoading(false);
		} else {
			const formData = new FormData();

			formData.append("file", selectedFiles);
			formData.append("courseProgressId", id);
			try {
				const res = await sendUploadedFiles(formData).unwrap();

				const newUploadedFile: TempUploadedFile = {
					...res,
					id: res.uploadedFileId,
				};

				setUploadedFilesArr((prev) => [...prev, newUploadedFile]);
			} catch (error) {
				console.error("Upload error", error);
			} finally {
				setIsFileLoading(false);
			}
		}
	}

	const { selectedDefaultParticipants, connectedUsers } = useSocket();

	const conntectedDefaultParticipants = connectedUsers.filter(
		(connected) => connected.isDefaultParticipant
	);

	const [isHandRaised, setIsHandRaised] = useState(false);

	useEffect(() => {
		handleRaiseHand(currentUserId, data?.id ?? "", isHandRaised);
	}, [isHandRaised]);

	return (
		<>
			<Breadcrumbs
				items={[
					{
						title: t("course.all-scenarios"),
						url: ROUTE_CONFIG.COURSES,
					},
					{
						title: data?.course?.name ?? "",
						url: `${ROUTE_CONFIG.COURSES}/${data?.course?.id}`,
					},
				]}
				requiredPermissions={[PermissionRoles.USER]}
			>
				{isJoinedVC ? (
					<div className="ml-auto flex flex-row  gap-1 ">
						{raisedHands.map((raised) => {
							return (
								<div
									key={raised.userId}
									className="flex flex-row gap-1 max-w-[120px] items-center bg-primary-blue rounded-3xl px-2 "
								>
									<Icon
										className={"text-brand-white text-[12px] font-medium shrink-0"}
										icon={faHandSolid}
									/>
									<p className="text-brand-white text-[13px] font-medium truncate">
										{raised.userFullName}
									</p>
								</div>
							);
						})}
					</div>
				) : null}
			</Breadcrumbs>

			<div className="w-full flex gap-6 p-6 h-[calc(100vh-154px)]">
				<div className="w-[70%] max-h-full flex flex-col justify-between">
					<div className="max-h-24">
						<div className="flex max-h-full justify-between items-start">
							<Typography
								gutterBottom
								className="overflow-hidden text-ellipsis w-[80%] h-full !text-primary-gray"
								sx={{
									fontWeight: "600",
									fontSize: "24px",
									lineHeight: "34px",
									mb: "0px",
								}}
								variant="body1"
							>
								{truncateText(currentCourseScenario?.Content?.[currentStage]?.phaseName ?? "", 140)}
							</Typography>

							<div className="flex items-center gap-3 self-center relative">
								{isCurrentUserERR
									? changeSelectedMode === "WHITEBOARD" && (
											<>
												{drawingCoords.length > 0 &&
													(isPresenter || isCurrentUserERR) &&
													drawingCoords.length > 0 && (
														<Button
															className="!w-[42px] !min-w-[42px] !px-0 [&_*]:!m-0"
															color={ButtonColor.ACTION_SECONDARY}
															fontSize={FontSize.M}
															image={<Icon icon={faTrash} />}
															size={ButtonSize.M}
															title=""
															onClick={handleClearDrawing}
														/>
													)}
												{(currentlySelectedFileAndPage?.blank ||
													currentlySelectedFileAndPage?.id) && (
													<HoveredButton
														color={ButtonColor.ACTION_SECONDARY}
														fontSize={FontSize.M}
														image={<Icon icon={faPencil} />}
														size={ButtonSize.M}
														title={isDrawingMode ? `${ts("stopDrawing")}` : `${ts("startDrawing")}`}
														onClick={() => {
															setIsDrawingMode((previousMode) => !previousMode);
														}}
													/>
												)}
											</>
										)
									: changeSelectedMode === "WHITEBOARD" && (
											<PermissionCheck requiredPermissions={[PermissionRoles.PRESENTER]}>
												<>
													{drawingCoords.length > 0 && (isPresenter || isCurrentUserERR) && (
														<Button
															className="!w-[42px] !min-w-[42px] !px-0 [&_*]:!m-0"
															color={ButtonColor.ACTION_SECONDARY}
															fontSize={FontSize.M}
															image={<Icon icon={faTrash} />}
															size={ButtonSize.M}
															title=""
															onClick={handleClearDrawing}
														/>
													)}
													<HoveredButton
														color={ButtonColor.ACTION_SECONDARY}
														fontSize={FontSize.M}
														image={<Icon icon={faPencil} />}
														size={ButtonSize.M}
														title={isDrawingMode ? `${ts("stopDrawing")}` : `${ts("startDrawing")}`}
														onClick={() => {
															setIsDrawingMode((previousMode) => !previousMode);
														}}
													/>
												</>
											</PermissionCheck>
										)}

								<div className="relative">
									<HoveredButton
										color={ButtonColor.ACTION_SECONDARY}
										fontSize={FontSize.M}
										image={
											<Icon
												icon={changeSelectedMode === "WHITEBOARD" ? faNewspaper : faChalkboardUser}
											/>
										}
										size={ButtonSize.M}
										title={changeSelectedMode === "CONTENT" ? ts("whiteboard") : ts("content")}
										onClick={() => {
											setChangeSelectedMode(
												changeSelectedMode === "WHITEBOARD" ? "CONTENT" : "WHITEBOARD"
											);
											setIsAudioPlaying(false);
											setIsDrawingMode(false);
										}}
									/>
									{((pageContent && pageContent.length > 0) ||
										(drawingCoords.length > 0 && currentlySelectedFileAndPage?.blank)) &&
										changeSelectedMode === "CONTENT" && (
											<span
												className="absolute top-0.5 right-0.5 grid min-h-[12px] min-w-[12px] translate-x-1/2 
											-translate-y-1/2 place-items-center rounded-md py-1 px-1 block bg-status-warning"
											></span>
										)}
								</div>

								{changeSelectedMode === "WHITEBOARD" &&
									(selectedPage || currentlySelectedFileAndPage?.blank) && (
										<>
											{isCurrentUserERR ? (
												<HoveredButton
													color={ButtonColor.ACTION_SECONDARY}
													image={<Icon icon={faArrowsRotate} />}
													title={ts("changeFile")}
													onClick={() => setIsChangeFileModalOpen(true)}
												/>
											) : (
												<PermissionCheck requiredPermissions={[PermissionRoles.PRESENTER]}>
													<HoveredButton
														color={ButtonColor.ACTION_SECONDARY}
														image={<Icon icon={faArrowsRotate} />}
														title={ts("changeFile")}
														onClick={() => setIsChangeFileModalOpen(true)}
													/>
												</PermissionCheck>
											)}
										</>
									)}
								{currentStageEndTimestamp > 0 && (
									<CountdownTimer
										key={currentStageEndTimestamp}
										currentStageEndTimestamp={currentStageEndTimestamp}
									/>
								)}
							</div>
						</div>
						{data?.course?.tag?.name && (
							<CourseTag className="w-fit" tag={data?.course?.tag?.name ?? ""} />
						)}
					</div>

					{currentlySelectedFileAndPage?.blank && changeSelectedMode === "WHITEBOARD" && (
						<div ref={divRef} className="w-full h-fit relative aspect-[2/1]">
							<div className="w-full h-full border-[1px]">
								<canvas
									ref={canvasRef}
									className="absolute z-10 w-full h-full object-contain"
									height={canvasRef.current?.clientHeight}
									width={canvasRef.current?.clientWidth}
									onMouseDown={(item: any) => handleStartDrawing(item)}
									onMouseMove={(item: any) => handleCurrentlyDrawing(item)}
									onMouseUp={handleStopDrawing}
								></canvas>
							</div>
						</div>
					)}

					{changeSelectedMode === "CONTENT" && (
						<div
							className={`${
								protocolCondition === "EXPANDED"
									? "min-h-[20%] h-full max-h-[20%]"
									: protocolCondition !== "MINIMIZED"
										? " "
										: "h-full max-h-[50%]"
							} overflow-auto space-y-5 custom-scrollbar flex-1`}
						>
							{typeof currentContent === "string" ? (
								<Typography
									sx={{ fontWeight: "400", color: "#686761", fontSize: "16px", mb: "0px" }}
									variant="body1"
								>
									<Markdown rehypePlugins={[rehypeRaw]}>{currentContent}</Markdown>
								</Typography>
							) : (
								currentContent
							)}
						</div>
					)}
					{isLoading && changeSelectedMode === "WHITEBOARD" ? (
						<Loader />
					) : changeSelectedMode === "WHITEBOARD" && selectedPage ? (
						<div
							className={`relative ${
								protocolCondition === "MINIMIZED"
									? "h-[calc(100%-154px)]"
									: protocolCondition === "EXPANDED"
										? "max-h-[20%]"
										: "h-[calc(100%-350px-96px)]"
							} w-full flex`}
						>
							{isCurrentUserERR ? (
								<>
									<div className="w-fit absolute top-[50%] right-0 -translate-y-[50%] translate-x-[50%] z-20">
										<Button
											className=""
											color={ButtonColor.ACTION_SECONDARY}
											disabled={currentlySelectedFileAndPage?.page === lastPage}
											image={<Icon icon={faChevronRight} />}
											size={ButtonSize.S}
											title=""
											onClick={() => {
												if (
													currentlySelectedFileAndPage?.id &&
													currentlySelectedFileAndPage?.page
												) {
													handleFileSelect(
														currentlySelectedFileAndPage?.id,
														currentlySelectedFileAndPage?.page + 1
													);
												}
											}}
										/>
									</div>

									<div className="absolute bottom-[50%] bottom-0 left-0 translate-y-[50%] -translate-x-[50%] z-20">
										<Button
											className=""
											color={ButtonColor.ACTION_SECONDARY}
											disabled={currentlySelectedFileAndPage?.page === 1}
											image={<Icon icon={faChevronLeft} />}
											size={ButtonSize.S}
											title=""
											onClick={() => {
												if (
													currentlySelectedFileAndPage?.id &&
													currentlySelectedFileAndPage?.page
												) {
													handleFileSelect(
														currentlySelectedFileAndPage?.id,
														currentlySelectedFileAndPage?.page - 1
													);
												}
											}}
										/>
									</div>
								</>
							) : (
								<PermissionCheck requiredPermissions={[PermissionRoles.PRESENTER]}>
									<>
										<div className="w-fit absolute top-[50%] right-0 -translate-y-[50%] translate-x-[50%] z-20">
											<Button
												className=""
												color={ButtonColor.ACTION_SECONDARY}
												disabled={currentlySelectedFileAndPage?.page === lastPage}
												image={<Icon icon={faChevronRight} />}
												size={ButtonSize.S}
												title=""
												onClick={() => {
													if (
														currentlySelectedFileAndPage?.id &&
														currentlySelectedFileAndPage?.page
													) {
														handleFileSelect(
															currentlySelectedFileAndPage?.id,
															currentlySelectedFileAndPage?.page + 1
														);
													}
												}}
											/>
										</div>

										<div className="absolute bottom-[50%] bottom-0 left-0 translate-y-[50%] -translate-x-[50%] z-20">
											<Button
												className=""
												color={ButtonColor.ACTION_SECONDARY}
												disabled={currentlySelectedFileAndPage?.page === 1}
												image={<Icon icon={faChevronLeft} />}
												size={ButtonSize.S}
												title=""
												onClick={() => {
													if (
														currentlySelectedFileAndPage?.id &&
														currentlySelectedFileAndPage?.page
													) {
														handleFileSelect(
															currentlySelectedFileAndPage?.id,
															currentlySelectedFileAndPage?.page - 1
														);
													}
												}}
											/>
										</div>
									</>
								</PermissionCheck>
							)}
							<div
								className=" w-full h-fit aspect-[2/1] overflow-y-auto overflow-x-visible scrollbar-hide flex   "
								onMouseEnter={() => {
									if (isDrawingMode) {
										return;
									} else {
										setIsExpandFileShowing(true);
									}
								}}
								onMouseLeave={() => {
									setIsExpandFileShowing(false);
								}}
							>
								{!currentlySelectedFileAndPage?.blank && !isFileExpanded && (
									<div className="relative  w-full h-full mx-auto">
										<canvas
											ref={canvasRef}
											className="absolute z-10 pointer-events-auto object-contain"
											onMouseDown={handleStartDrawing}
											onMouseMove={handleCurrentlyDrawing}
											onMouseUp={handleStopDrawing}
										/>
										<img
											key={selectedPage?.id}
											ref={imgRef}
											alt={`Page ${selectedPage?.pageNumber}`}
											className="w-full h-full object-contain"
											src={selectedPage?.base64Url}
											onClick={() => !isDrawingMode && setIsFileExpanded(true)}
											onLoad={(e) => {
												const img = e.currentTarget;
												const { canvas } = getCtxAndCanvas();

												if (canvas) {
													canvas.width = img.clientWidth;
													canvas.height = img.clientHeight;
												}
											}}
										/>
									</div>
								)}
								{isExpandFileShowing && (
									<Button
										className=" w-min  absolute top-1/2  -translate-y-1/2 right-1/2 translate-x-1/2 z-10 "
										color={ButtonColor.ACTION_SECONDARY}
										image={<Icon icon={faArrowUpRightAndArrowDownLeftFromCenter} />}
										size={ButtonSize.M}
										title=""
										onClick={handlePopUpFile}
									/>
								)}
							</div>
						</div>
					) : (
						""
					)}

					{changeSelectedMode === "WHITEBOARD" &&
						!currentlySelectedFileAndPage?.blank &&
						(isCurrentUserERR ? (
							<div
								className={`overflow-y-auto scrollbar-hide ${
									protocolCondition === "MINIMIZED"
										? "h-[calc(100%-154px)]"
										: protocolCondition === "EXPANDED"
											? "max-h-[20%]"
											: "h-[calc(100%-350px-96px)]"
								}`}
							>
								{!selectedPage && (
									<p className=" text-sm mb-4 mt-4 text-primary-gray text-[14px] font-semibold text-center">
										{isCurrentUserERR || isPresenter ? ts("selectFile") : ts("noFilesSelected")}
										<div
											className="w-full mb-3 hover:cursor-pointer bg-white border border-gray-200 rounded-lg px-4 py-2 flex items-center justify-between shadow-sm"
											onClick={() => {
												handleFileSelect(null, null, true);
												setIsDrawingMode(true);
											}}
										>
											<div className="flex flex-col text-left">
												<p className="text-gray-800 font-medium text-sm truncate max-w-[340px] py-2">
													{ts("emptyCanvas")}
												</p>
											</div>
										</div>
									</p>
								)}
								{uploadedFiles?.length > 0 && !selectedPage && (
									<div className="w-full mb-4  mt-4 space-y-3">
										{uploadedFiles.map((file) => (
											<div
												key={file.id}
												className="w-full hover:cursor-pointer bg-white border border-gray-200 rounded-lg px-4 py-2 flex items-center justify-between shadow-sm"
												onClick={() => {
													handleFileSelect(Number(file.id), 1);
												}}
											>
												<div className="flex flex-row justify-between min-w-full ">
													<div className="text-left">
														<p className="text-gray-800 font-medium text-sm truncate w-max">
															{file.name}
														</p>
														<p className="text-xs text-gray-500">
															{file.pageCount} {t("courses.progress.pages")}
														</p>
													</div>
													<Box color="#D9A400" display="flex">
														<Box
															borderRadius={1}
															boxShadow={1}
															height={28}
															p="0px 5px"
															sx={{ cursor: "pointer" }}
															onClick={(e) => {
																e.stopPropagation();
																handleRemoveUploadedFile(file.id);
																setUploadedFiles((state) => state.filter((f) => f.id !== file.id));
															}}
														>
															<DeleteOutlineRounded />
														</Box>
													</Box>
												</div>
											</div>
										))}
									</div>
								)}{" "}
								{!selectedPage && (
									<Button
										className={`max-w-[80px] min-h-[50px] flex px-2 py-2 text-xl justify-center content-center justify-self-center`}
										color={ButtonColor.ACTION_SECONDARY}
										fontSize={FontSize.M}
										image={<SvgIcon svgIcon={UploadCloud} />}
										size={ButtonSize.M}
										title={""}
										onClick={() => setIsUploadModalOpen(true)}
									/>
								)}
							</div>
						) : (
							<PermissionCheck requiredPermissions={[PermissionRoles.PRESENTER]}>
								<div className="">
									{!selectedPage && (
										<p className=" text-sm mb-4 mt-4 text-primary-gray text-[14px] font-semibold text-center">
											{isCurrentUserERR || isPresenter ? ts("selectFile") : ts("noFilesSelected")}
											<div
												className="w-full mb-3 hover:cursor-pointer bg-white border border-gray-200 rounded-lg px-4 py-2 flex items-center justify-between shadow-sm"
												onClick={() => {
													handleFileSelect(null, null, true);
													setIsDrawingMode(true);
												}}
											>
												<div className="flex flex-col text-left">
													<p className="text-gray-800 font-medium text-sm truncate max-w-[340px] py-2">
														{ts("emptyCanvas")}
													</p>
												</div>
											</div>
										</p>
									)}
									{uploadedFiles?.length > 0 && !selectedPage && (
										<div className="w-full mb-4  mt-4 space-y-3">
											{uploadedFiles.map((file) => (
												<div
													key={file.id}
													className="w-full hover:cursor-pointer bg-white border border-gray-200 rounded-lg px-4 py-2 flex items-center justify-between shadow-sm"
													onClick={() => {
														handleFileSelect(Number(file.id), 1);
													}}
												>
													<div className="flex flex-row justify-between min-w-full ">
														<div className="text-left">
															<p className="text-gray-800 font-medium text-sm truncate w-max">
																{file.name}
															</p>
															<p className="text-xs text-gray-500">
																{file.pageCount} {t("courses.progress.pages")}
															</p>
														</div>
														<Box color="#D9A400" display="flex">
															<Box
																borderRadius={1}
																boxShadow={1}
																height={28}
																p="0px 5px"
																sx={{ cursor: "pointer" }}
																onClick={(e) => {
																	e.stopPropagation();
																	handleRemoveUploadedFile(file.id);
																	setUploadedFiles((state) =>
																		state.filter((f) => f.id !== file.id)
																	);
																}}
															>
																<DeleteOutlineRounded />
															</Box>
														</Box>
													</div>
												</div>
											))}
										</div>
									)}
									<Button
										className={`max-w-[100px] min-h-[40px] flex px-2 py-2 text-xl justify-center content-center justify-self-center`}
										color={ButtonColor.ACTION_SECONDARY}
										fontSize={FontSize.M}
										image={<SvgIcon svgIcon={UploadCloud} />}
										size={ButtonSize.M}
										title={""}
										onClick={() => setIsUploadModalOpen(true)}
									/>
								</div>
							</PermissionCheck>
						))}
					<Protocol
						// The leader always writes the protocol, whatever their organisation role (BCM360-359).
						chatPermissions={isCurrentUserERR ? [] : [PermissionRoles.PROTOCOL_WRITER]}
						currentPhaseId={currentCourseScenario?.Content?.[currentStage]?.id ?? -1}
						exerciseName={data?.course?.name ?? currentCourseScenario?.scenarioName ?? ""}
						handleOpenSpoilerModal={
							currentCourseScenario?.Content?.[currentStage]?.spoilerContent?.content
								? !currentStageSpoiler
									? () => setIsSpoilerModalShown(true)
									: () => setCurrentShowingContentInfo(currentStageSpoiler)
								: undefined
						}
						isLastPhase={
							!currentCourseScenario?.Content?.[currentStage]?.decisionOptions ||
							currentCourseScenario?.Content?.[currentStage]?.decisionOptions?.length === 0
						}
						phases={currentCourseScenario?.Content ?? []}
						protocolCondition={protocolCondition}
						setProtocolCondition={setProtocolCondition}
					/>
				</div>
				<div className="h-full w-[30%] space-y-6">
					<div className="flex items-center justify-end gap-5">
						<div>
							<div className="relative translate-x-[11px] z-40">
								<div className="flex gap-2">
									{isJoinedVC ? (
										<Button
											className={`max-w-min `}
											color={isHandRaised ? ButtonColor.PRIMARY_BLUE : ButtonColor.ACTION}
											image={
												isHandRaised ? (
													<FontAwesomeIcon icon={faHandSolid} />
												) : (
													<FontAwesomeIcon icon={faHand} />
												)
											}
											title={""}
											onClick={() => {
												setIsHandRaised(!isHandRaised);
											}}
										/>
									) : null}
									<Button
										className={`max-w-min`}
										color={ButtonColor.ACTION}
										image={<FontAwesomeIcon icon={faPhone} />}
										title={""}
										onClick={() => {
											setIsJoinedVC(true);
											setIsHoveringOnCall((state) => !state);
										}}
									/>
								</div>
								{isJoinedVC ? (
									<>
										{data && isJoinedVC && currentUser && (
											<VoiceChat
												classname={`${isHoveringOnCall ? "block" : "hidden"} absolute ${
													currentUser?.role?.code === Role.GLOBAL_ADMIN ||
													currentUser?.role?.code === Role.ADMIN
														? "top-[100%] left-0 translate-y-[10%] -translate-x-[19%] z-40 "
														: "top-[100%] translate-y-[10%] right-0 translate-x-[30%] z-40 "
												} `}
												courseProgressId={data?.id}
												user={currentUser}
												onDisconnect={() => {
													setIsJoinedVC(false);
													setIsHoveringOnCall(false);
													setIsHandRaised(false);
												}}
											/>
										)}
										<span
											className="absolute top-0.5 right-0.5 grid min-h-[12px] min-w-[12px] translate-x-1/2 
										-translate-y-1/2 place-items-center rounded-md py-1 px-1 block bg-status-success"
										></span>
									</>
								) : (
									<span
										className="absolute top-0.5 right-0.5 grid min-h-[12px] min-w-[12px] translate-x-1/2 
								-translate-y-1/2 place-items-center rounded-md py-1 px-1 block bg-status-error"
									></span>
								)}
							</div>
						</div>
						<ListConnectedUsers />
						{currentUserId && data?.user?.id && currentUserId === data?.user?.id && (
							<Button
								className="py-2 px-4 !h-[44px] !w-fit"
								color={ButtonColor.ACTION}
								image={
									<div className="mr-2 flex items-center justify-center">
										<Icon className="w-5 h-5" icon={faPlus} />
									</div>
								}
								title={ts("add-team")}
								onClick={() => setIsShowAddTeamModal(true)}
							></Button>
						)}
					</div>
					<TabsContainer
						containerClassName="h-[calc(100%-68px)] flex flex-col rounded-[20px] border border-border"
						tabContainerClassName="px-4 pt-4 border-b border-border-soft w-full"
						tabContentContainerClassName="!mt-0 flex-1 flex flex-col !h-[60px]"
						tabItemClassName="!py-0 !px-4 !pb-3"
					>
						<Tab title={ts("chat")}>
							<Chat
								chatBodyClassName="h-[calc(100%-120px)]"
								chatContainerClassName="h-[calc(100%-120px)]"
								messages={chatMessages}
								sendMessage={sendChatMessage}
							/>
						</Tab>
						<Tab title={ts("information")}>
							<InformationTab
								alreadyHasOpenedContentIds={alreadyHasOpenedContentIds}
								containerClassName="h-[calc(100%-60px)]"
								setCurrentShowingContentId={setCurrentShowingContentId}
								setCurrentShowingContentInfo={setCurrentShowingContentInfo}
								stageContent={stageContent}
							/>
						</Tab>
					</TabsContainer>
				</div>
			</div>
			{isShowAddTeamModal && data && (
				<AddTeamModal
					conntectedDefaultParticipants={conntectedDefaultParticipants}
					courseProgress={data}
					isOpen={isShowAddTeamModal}
					setIsOpen={setIsShowAddTeamModal}
				/>
			)}
			<SpoilerModal
				isShowSpoiler={isSpoilerModalShown}
				sendScenarioAction={sendScenarioAction}
				setIsShowSpoiler={setIsSpoilerModalShown}
			/>
			{isChangeFileModalOpen && (
				<Modal
					aboveHeader={<FlagHeader />}
					dialogContentClassName="!p-2  overflow-y-auto max-h-60 scrollbar-hide"
					handleClose={() => setIsChangeFileModalOpen(false)}
					handleSave={() => setIsUploadModalOpen(true)}
					isOpened={isChangeFileModalOpen}
					submitButtonIcon={<SvgIcon className="mr-2" svgIcon={UploadCloud} />}
					submitButtonText={t("courses.upload.modalBtn")}
					title={ts("changeFile")}
				>
					<div
						className="w-full mb-3 hover:cursor-pointer bg-white border border-gray-200 rounded-lg px-4 py-2 flex items-center justify-between shadow-sm"
						onClick={() => {
							handleFileSelect(null, null, true);
							setIsChangeFileModalOpen(false);
							setIsDrawingMode(true);
						}}
					>
						<div className="flex flex-col text-left">
							<p className="text-gray-800 font-medium text-sm truncate max-w-[340px] py-2">
								{ts("emptyCanvas")}
							</p>
						</div>
					</div>
					{uploadedFiles?.map((file) => (
						<div
							key={file.id}
							className="w-full mb-3 hover:cursor-pointer bg-white border border-gray-200 rounded-lg px-4 py-2 flex items-center justify-between shadow-sm"
							onClick={() => {
								if (file.id !== currentlySelectedFileAndPage?.id) {
									handleFileSelect(Number(file.id), 1);
									setIsChangeFileModalOpen(false);
								}
							}}
						>
							<div className="flex flex-col text-left">
								<p className="text-gray-800 font-medium text-sm truncate max-w-[300px]">
									{file.name}
								</p>
								<p className="text-xs text-gray-500">
									{file.pageCount} {t("courses.progress.pages")}
								</p>
							</div>
							<Box color="#D9A400" display="flex">
								<Box
									borderRadius={1}
									boxShadow={1}
									height={28}
									p="0px 5px"
									sx={{ cursor: "pointer" }}
									onClick={(e) => {
										e.stopPropagation();
										handleRemoveUploadedFile(file.id);
										setUploadedFiles((state) => state.filter((f) => f.id !== file.id));
									}}
								>
									<DeleteOutlineRounded />
								</Box>
							</Box>
						</div>
					))}
				</Modal>
			)}
			<Modal
				dialogContentClassName="!p-2 max-h-[80vh] overflow-auto scrollbar-hide"
				handleClose={() => setIsFileExpanded(false)}
				isOpened={isFileExpanded}
				showActions={false}
				size="xl"
				title=""
			>
				<div className=" min-w-full min-h-full relative flex">
					{!currentlySelectedFileAndPage?.blank && isFileExpanded && (
						<div className="mx-auto h-full w-full self-center relative aspect-[2/1]">
							<canvas
								ref={canvasRefModal}
								className="w-[100%] h-[100%] absolute z-10"
								height={imgRefModal.current?.clientHeight}
								width={imgRefModal.current?.clientWidth}
							></canvas>
							<img
								key={selectedPage?.id}
								ref={imgRefModal}
								alt={`Page ${selectedPage?.pageNumber}`}
								className="w-full h-full object-contain"
								src={selectedPage?.base64Url}
							/>
						</div>
					)}
					{isCurrentUserERR ? (
						<>
							<div className="z-20 w-fit absolute top-[50%] right-0 -translate-y-[50%] -translate-x-[50%]">
								<Button
									className="z-20"
									color={ButtonColor.ACTION_SECONDARY}
									disabled={currentlySelectedFileAndPage?.page === lastPage}
									image={<Icon icon={faChevronRight} />}
									size={ButtonSize.S}
									title=""
									onClick={() => {
										if (currentlySelectedFileAndPage?.id && currentlySelectedFileAndPage?.page) {
											handleFileSelect(
												currentlySelectedFileAndPage?.id,
												currentlySelectedFileAndPage?.page + 1
											);
										}
									}}
								/>
							</div>

							<div className="z-20 w-fit absolute bottom-[50%] bottom-0 left-0 translate-y-[50%] translate-x-[50%]">
								<Button
									className="z-20"
									color={ButtonColor.ACTION_SECONDARY}
									disabled={currentlySelectedFileAndPage?.page === 1}
									image={<Icon icon={faChevronLeft} />}
									size={ButtonSize.S}
									title=""
									onClick={() => {
										if (currentlySelectedFileAndPage?.id && currentlySelectedFileAndPage?.page) {
											handleFileSelect(
												currentlySelectedFileAndPage?.id,
												currentlySelectedFileAndPage?.page - 1
											);
										}
									}}
								/>
							</div>
						</>
					) : (
						<PermissionCheck requiredPermissions={[PermissionRoles.PRESENTER]}>
							<>
								<div className="w-fit absolute top-[50%] right-0 -translate-y-[50%] -translate-x-[50%]">
									<Button
										className=""
										color={ButtonColor.ACTION_SECONDARY}
										disabled={currentlySelectedFileAndPage?.page === lastPage}
										image={<Icon icon={faChevronRight} />}
										size={ButtonSize.S}
										title=""
										onClick={() => {
											if (currentlySelectedFileAndPage?.id && currentlySelectedFileAndPage?.page) {
												handleFileSelect(
													currentlySelectedFileAndPage?.id,
													currentlySelectedFileAndPage?.page + 1
												);
											}
										}}
									/>
								</div>

								<div className="absolute bottom-[50%] bottom-0 left-0 translate-y-[50%] translate-x-[50%]">
									<Button
										className=""
										color={ButtonColor.ACTION_SECONDARY}
										disabled={currentlySelectedFileAndPage?.page === 1}
										image={<Icon icon={faChevronLeft} />}
										size={ButtonSize.S}
										title=""
										onClick={() => {
											if (currentlySelectedFileAndPage?.id && currentlySelectedFileAndPage?.page) {
												handleFileSelect(
													currentlySelectedFileAndPage?.id,
													currentlySelectedFileAndPage?.page - 1
												);
											}
										}}
									/>
								</div>
							</>
						</PermissionCheck>
					)}
				</div>
			</Modal>

			<Modal
				aboveHeader={<FlagHeader />}
				dialogContentClassName="!p-2 "
				disableClose={uploadIsLoading}
				disableSave={uploadIsLoading}
				handleClose={() => handleCloseStartModal(uploadedFilesArr)}
				handleSave={() => {
					getScenarioActualData();
					setIsUploadModalOpen(false);
					setUploadedFilesArr([]);
				}}
				isLoading={uploadIsLoading}
				isOpened={isUploadModalOpen}
				submitButtonColor={ButtonColor.ACTION}
				submitButtonText={t("courses.upload.modalBtn")}
				title={t("courses.upload.modalTitle")}
			>
				<Stack className="overflow-y-auto max-h-60 scrollbar-hide" spacing={0.4}>
					{uploadedFilesArr?.length > 0 && (
						<div className="w-full mb-4 space-y-3">
							{uploadedFilesArr?.map((file) => (
								<div
									key={file.id}
									className="w-full bg-white border border-gray-200 rounded-lg px-4 py-2 flex items-center justify-between shadow-sm"
								>
									<div className="flex flex-col text-left">
										<p className="text-gray-800 font-medium text-sm truncate max-w-[300px]">
											{file.name}
										</p>
										<p className="text-xs text-gray-500">
											{file.pageCount} {ts("pages")}
										</p>
									</div>

									<Box color="#D9A400" display="flex">
										<Box
											borderRadius={1}
											boxShadow={1}
											height={28}
											p="0px 5px"
											sx={{ cursor: "pointer" }}
											onClick={(e) => {
												e.stopPropagation();
												handleRemoveUploadedFile(file.id);
											}}
										>
											<DeleteOutlineRounded />
										</Box>
									</Box>
								</div>
							))}
						</div>
					)}
				</Stack>
				<FileUploader
					disabled={uploadIsLoading}
					handleChange={(file: File | File[]) => {
						const singleFile = Array.isArray(file) ? file[0] : file;

						handleFileUpload(singleFile, id ?? "");
					}}
					maxSize={Math.round(maxFileSizeInBytes / 1024 / 1024)}
					multiple={true}
					name="file"
					types={["PDF", "PPTX", "DOCX"]}
				>
					<Box
						alignItems="center"
						color="gray600.main"
						display="flex"
						flexDirection="column"
						height="100%"
						justifyContent="center"
						marginTop="15px"
						sx={{ cursor: "pointer" }}
						textAlign="center"
					>
						{uploadIsLoading ? (
							<Icon className="animate-spin mt-5" icon={faLoader} size="lg" />
						) : (
							<>
								<SvgIcon svgIcon={UploadCloud} />
								<Typography className="text-primary-gray" variant="body2">
									{t("courses.upload.title")}
								</Typography>

								<Typography className="text-primary-gray" variant="caption">
									{t("courses.upload.description", {
										sizeInMB: Math.round(maxFileSizeInBytes / 1024 / 1024),
									})}
								</Typography>
							</>
						)}
					</Box>
				</FileUploader>
			</Modal>
		</>
	);
}
